/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { Button, Icon } from 'sarsaparilla';
import type { MapFile } from '../../../types/permit';

interface MapsTypes {
    maps: Array<MapFile>;
}
export default function Maps({ maps = [] }: MapsTypes) {
    return (
        <div className="tp-maps">
            <div className="tp-maps-list">
                {maps.map(({ url: download, fsize, name }, i) => {
                    return (
                        <div className="tp-map" key={i}>
                            <div className="tp-map-image-container">
                                <img
                                    src={`${process.env.CDN}/img/map.png`}
                                    alt="" // alt desc not needed for decorative images
                                    className="tp-map-image"
                                />
                            </div>
                            <div className="tp-map-title">{name}</div>
                            <div className="tp-map-metadata">
                                <div className="tp-map-metadata-item">
                                    <div className="tp-map-cta">
                                        <Button
                                            appearance="link"
                                            iconBeforeElement={
                                                <Icon iconName="file-download" />
                                            }
                                            href={download}
                                            aria-label="Download pdf"
                                        >
                                            Download ({fsize?.toFixed(0)}kb)
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
